<template>
        <v-row justify="center">
            <v-list-item

                         color="primary"
                         dark
                         @click="dialog=true"
            >

                    <v-list-item-icon>
                        <v-img src="../../../../../assets/svg/CommentIcon.svg" class="comment-box"></v-img>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title class="comment">Add/View Comments</v-list-item-title>
                    </v-list-item-content>
            </v-list-item>


            <v-dialog
                    v-model="dialog"
                    width="450"
            >
                <v-card>
                    <Loader :loading="loading" :message="message"/>
                    <v-toolbar class="box"  @click.stop="dialog = false">
                        <v-icon>mdi-close</v-icon>
                        <v-toolbar-title>Close</v-toolbar-title>
                    </v-toolbar>
                    <div class="comment-content">
                        <v-card-title class="comment-heading">Comments </v-card-title>

                        <v-card-text class="comment-info">
                            These are the comments from your colleagues. You can add yours:
                        </v-card-text>
                        <v-row class="scroll-height">
                            <div v-for="(comment,index) in commentList" :key="comment._id" class="adminid textareaComment">
                                {{comment}}
                              <br>
                              <br>
                              <br>
                              <small>{{index}}</small>
                            </div>

                        </v-row>

                        <v-textarea
                                outlined
                                name="input-7-4"
                                height="100px"
                                class="ml-3 mr-2 mb-5 comment-input"
                                label="Write message (optional)"
                                v-model="comment"
                        ></v-textarea>
                        <v-card-actions>
                            <v-btn
                                    color="red"
                                    outlined
                                    x-large
                                    @click="dialog = false"
                            >
                                Cancel
                            </v-btn>
                            <div v-if="comment!==''">
                            <v-btn
                                    color="error"
                                    depressed
                                    x-large
                                    @click="sendComment"
                                    class="ml-5"
                            >
                                Add comment
                            </v-btn>
                            </div>
                        </v-card-actions>

                    </div>
                </v-card>
            </v-dialog>
        </v-row>
</template>

<script>
import axios from 'axios'
import {getAllInteractionComment, sendInteractionComment} from "../../../../../services/ApiServices";
import {mapGetters} from "vuex";
import Loader from "./Loader";

export default {
  name: "CommentDialog",
  components: {Loader},
  props: ['applicantRecord'],
  data() {
    return {
      dialog: false,
      comment: "",
      commentList: "",
      loading: false,
      message: "Loading...",


            }
        },
        methods:{

            sendComment(e){
                // this.loading=true
                e.preventDefault();
                const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
                axios.post(sendInteractionComment(this.applicantEmail), "",{headers:elderHeader,
                params:{comment:this.comment}})
                .then(res=>{
                    // this.loading=false
                    this.fetchComment()
                    this.comment=""
                    console.log(res)
                }).catch(err=>{
                    // this.loading=false
                    console.log(err)
                })

            },
            fetchComment(){
                this.loading=true
                const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
                console.log(this.applicantEmail)
                axios.get(getAllInteractionComment(this.applicantEmail),{headers:elderHeader})
                .then(res=>{
                    console.log(res)
                  this.commentList = res.data;
                  console.log(this.commentList)
                  this.loading = false

                })
                .catch(err=>{
                  console.log(err)
                  this.loading = false
                })
            }

        },
        created() {
            this.fetchComment()
        },

        computed:{
        ...mapGetters(['applicantEmail'])
        }

    }
</script>

<style scoped>
    .comment{
        font-family: IBM Plex Sans !important;
        font-style: normal !important ;
        font-weight: 500 !important;
        font-size: 16px !important;
        line-height: 20px !important;
        display: flex;
        align-items: center !important;
        letter-spacing: 0.02em;
        color: #431288;
    }
    .comment-box{
        background: rgba(67, 18, 136, 0.2);
        border-radius: 8px;
        padding: 3px;
    }
    .comment-heading{
        font-weight: 500!important;
        font-size: 30px !important;
        line-height: 33px!important;
        letter-spacing: -0.02em;
        color: #2B1C1C !important;
    }
    .comment-info{
        font-size: 14px !important;
        line-height: 18px !important;
        color: #2B1C1C;
    }
    .comment-input{
        font-size: 16px !important;
        line-height: 20px !important;
        display: flex;
        align-items: center!important;
        letter-spacing: 0.05em;

        color: #2B1C1C !important;
    }
    .box{
        box-shadow: none!important;
        cursor: pointer;
    }
    .comment-content{
        margin-left: 55px;
        margin-right: 55px;
        font-family: IBM Plex Sans !important;
        font-style: normal!important;
        font-weight: normal;

    }
    .textareaComment{
        width: 320px !important;
        margin-left: 25px !important;
        height: 90px !important;
        margin-top: 10px !important;
        border: 1px solid rgba(150, 12, 12, 0.5);
        box-sizing: border-box;
        border-radius: 6px;
        background-color: #ffffff;
        resize: none;
        overflow: auto;
        margin-bottom: 12px !important;
        padding-left: 20px;
        padding-top: 10px;
    }
    .adminid{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 18px;
        letter-spacing: 0.01em;

    }
    .scroll-height{
      height: 260px;
      overflow-y: scroll;
      padding-bottom: 20px;
    }

</style>